import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';

interface AdminStatCardProps {
  title: string;
  value: string | number;
  icon: React.ReactNode;
  trend?: {
    value: number | string;
    isPositive?: boolean;
  };
  subtitle?: string;
}

export function AdminStatCard({
  title,
  value,
  icon,
  trend,
  subtitle
}: AdminStatCardProps) {
  const { isDark } = useTheme();

  return (
    <div
      className="rounded-lg p-5 transition-shadow"
      style={{
        backgroundColor: isDark ? '#1D293D' : '#FFFFFF',
        border: `1px solid ${isDark ? '#314158' : '#E2E8F0'}`,
        boxShadow: isDark ? '0px 1px 2px rgba(2, 6, 24, 0.5)' : '0px 1px 2px rgba(43, 127, 255, 0.1)',
      }}
    >
      <div className="flex items-center justify-between mb-3">
        <span
          className="text-xs font-medium"
          style={{ color: isDark ? '#90A1B9' : '#62748E' }}
        >
          {title}
        </span>
        <div
          className="flex items-center justify-center"
          style={{
            width: 36,
            height: 36,
            borderRadius: 12,
            backgroundColor: isDark ? '#314158' : '#F1F5F9',
          }}
        >
          {icon}
        </div>
      </div>
      <div
        className="text-2xl font-bold mb-2"
        style={{ color: isDark ? '#E2E8F0' : '#1E293B' }}
      >
        {value}
      </div>
      {trend && (
        <div
          className="text-xs font-medium"
          style={{
            color: trend.isPositive !== false
              ? (isDark ? '#5EE9B5' : '#009966')
              : (isDark ? '#FF637E' : '#EF4444'),
          }}
        >
          {typeof trend.value === 'number' && trend.isPositive !== false ? '+' : ''}{trend.value}
        </div>
      )}
      {subtitle && (
        <div
          className="text-xs mt-1"
          style={{ color: isDark ? '#90A1B9' : '#64748B' }}
        >
          {subtitle}
        </div>
      )}
    </div>
  );
}
